export default {
  mounted: (el, binding) => {
    const onResizeCallback = binding.value;
    el.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const cr = entry.contentRect;
        onResizeCallback({ width: cr.width, height: cr.height });
      });
    });
    el.resizeObserver.observe(el);
  }
};
